<template>
    <div>
        <div class="row">
            <div class="col-6" v-for="(getProduct,index) in props.products" :key="`pros+${index}`">
                <!-- <div class="L2_product_title">{{ getProduct.name }}</div> -->
                <!-- <div v-for="(product,index) in getProduct.products" :key="`pros+l2+${index}`"> -->
                    <a :href="getProduct.link" class="matching-l2products-details col q-mb-md q-mx-sm">
                        <div>
                            <img class="product-image" :src="categoryDetails[getProduct.value].img || ''" />
                        </div>
                        <div class="product-details-wrapper">
                            <div class="product-title" v-html="getHighlightProductName(getProduct.value)"></div>
                            <div class="product-count-result">{{getProduct.count}} results</div>
                        </div>
                    </a>
                <!-- </div> -->
            </div>
        </div>
    </div>
</template>

<script setup>
/* eslint-disable */
import { defineProps,computed } from "vue";
import { useSearchStore } from '../../stores/search-store'
import { useCategoryStore } from '../../stores/category-store'
import { storeToRefs } from 'pinia';

const searchStore = useSearchStore()

const categoryStore = useCategoryStore();
const { categoryDetails } = storeToRefs(categoryStore);

const props=defineProps({
    products: Array
})
const getSearchedString = computed(()=>{
    return searchStore.searchedString;
  })
  
  function getHighlightProductName(productName){
    // console.log(productName,'==',getSearchedString.value);
    if(productName){
        const prod=productName.toLowerCase();
        const searchString=getSearchedString.value.toLowerCase() || "";
        return prod.includes(searchString) ? `<em class='v-hightlight'>${productName}</em>` : `${productName}`;
    }
    return "";
  }
</script>

<style scoped lang="scss">
.matching-l2products-details {
    display: flex;
    align-items: center;
    padding: 10px;
    background: #FEFEFE;
    border: 1px solid #B3B3B3;
    border-radius: 8px;
    text-decoration: none;

    .product-image{
        width: 60px;
        height: 60px;
    }

    .product-details-wrapper{
        margin-left: 12px;
    }
    .product-title{
        font-weight: 700;
        font-size: 17px;
        line-height: 24px;
        letter-spacing: 0.5px;
        text-transform: uppercase;
        color: $apg-dark-grey;
    }
    .product-count-result{
        font-size: 15px;
        color: $apg-navigation-grey;
    }
}

.L2_product_title{
    font-size: 17px;
    font-weight: 700;
    text-transform: uppercase;
    color: $apg-navigation-grey;
    margin-left: 10px;
    margin-bottom: 10px;
    padding-bottom: 5px;
    border-bottom: 1px solid #a9a4a4;
}
</style>